import React from 'react';
import PropTypes from 'prop-types';
import ShippingSearchArticles from '../ShippingSearchArticles';
import ShippingSearchDI from '../ShippingSearchDI';
import ShippingSearchDrivers from '../ShippingSearchDrivers';
import ShippingSearchStores from '../ShippingSearchStores';
import ShippingSearchStoresAddresses from '../ShippingSearchStoresAddress';
import ShippingSearchTrailers from '../ShippingSearchTrailers';
import ShippingSearchVehicles from '../ShippingSearchVehicles';

const ShippingSearchOverlays = ({
  formShipping,
  setFormShipping,
  selectStores,
  menuPermissions,
  setOpenChangeTypeOfPrice,
  articleSearch,
  diSearch,
  driverSearch,
  storeSearch,
  storeAddressSearch,
  vehicleSearch,
  trailerSearch,
}) => (
  <>
    <ShippingSearchArticles
      showModalSearchArticles={articleSearch.open}
      setShowModalSearchArticles={articleSearch.setOpen}
      formShipping={formShipping}
      setFormShipping={setFormShipping}
    />
    <ShippingSearchDI
      showModalSearchDI={diSearch.open}
      setShowModalSearchDI={diSearch.setOpen}
      formShipping={formShipping}
      setFormShipping={setFormShipping}
      setOpenChangeTypeOfPrice={setOpenChangeTypeOfPrice}
      menuPermissions={menuPermissions}
    />
    <ShippingSearchDrivers
      showModalSearchDrivers={driverSearch.open}
      setShowModalSearchDrivers={driverSearch.setOpen}
      formShipping={formShipping}
      setFormShipping={setFormShipping}
    />
    <ShippingSearchStores
      showModalSearchStores={storeSearch.open}
      setShowModalSearchStores={storeSearch.setOpen}
      selectStores={selectStores}
      setFormShipping={setFormShipping}
    />
    <ShippingSearchStoresAddresses
      showModalSearchStoresAddress={storeAddressSearch.open}
      setShowModalSearchStoresAddress={storeAddressSearch.setOpen}
      formShipping={formShipping}
      setFormShipping={setFormShipping}
      selectStores={selectStores}
    />
    <ShippingSearchVehicles
      showModalSearchVehicles={vehicleSearch.open}
      setShowModalSearchVehicles={vehicleSearch.setOpen}
      setFormShipping={setFormShipping}
      formShipping={formShipping}
    />
    <ShippingSearchTrailers
      showModalSearchTrailers={trailerSearch.open}
      setShowModalSearchTrailers={trailerSearch.setOpen}
      setFormShipping={setFormShipping}
      formShipping={formShipping}
    />
  </>
);

const searchStateType = PropTypes.shape({
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
});

ShippingSearchOverlays.propTypes = {
  formShipping: PropTypes.object.isRequired,
  setFormShipping: PropTypes.func.isRequired,
  selectStores: PropTypes.string.isRequired,
  menuPermissions: PropTypes.object.isRequired,
  setOpenChangeTypeOfPrice: PropTypes.func.isRequired,
  articleSearch: searchStateType.isRequired,
  diSearch: searchStateType.isRequired,
  driverSearch: searchStateType.isRequired,
  storeSearch: searchStateType.isRequired,
  storeAddressSearch: searchStateType.isRequired,
  vehicleSearch: searchStateType.isRequired,
  trailerSearch: searchStateType.isRequired,
};

export default ShippingSearchOverlays;
